import React from 'react';
import bannerStatue from '../../../../assets/images/bannerStatue.png';
import bannerExperienceImage from '../../../../assets/images/banner-experience-img.png';

const BannerKV = () => {
    return (
        <>
            <div className="banner-statue">
                <img src={bannerStatue} alt="Statue" className="banner-image" />
            </div>
            <div className="banner-experience">
                <div className="experience-number">
                    <h3>20+ years</h3>
                    <p>experience</p>
                    <div className="experience-image">
                        <img src={bannerExperienceImage} alt="" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default BannerKV;
// try
